import React, { useEffect, useState } from "react";
import NavBar from "../../components/NavBar";
import AppFooter from "../../components/footer";
import { Container, Typography, Grid, Box, Chip } from "@mui/material";
import BlogsCard from "../../components/cards/BlogsCard";
import { getAllBlogs } from "../../services/blogsFn";
import BlogsCardSkeleton from "../../components/skeletons/BlogCardSkeleton";
import { useSelector } from "react-redux";

const ALL_CATEGORY = [
  {
    title_en: "Ecommerce",
    title_ro: "Comerț electronic",
    type: "ecommerce",
  },
  {
    title_en: "Cleaning Service",
    title_ro: "Serviciu de curatenie",
    type: "cleaning",
  },
  {
    title_en: "Car Service",
    title_ro: "Service auto",
    type: "car",
  },
];

const AllBlogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { currentLanguage } = useSelector((state) => state.translationReducer);
  const fetchBlogs = async () => {
    try {
      const response = await getAllBlogs();
      if (response.data.status === "success") {
        setBlogs(response.data.data.blogs);
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  if (blogs.length === 0 && isLoading === false) {
    return (
      <>
        <NavBar />
        <Container sx={{ mt: 16 }}>
          <Typography variant="h5" textAlign="center">
            No Blogs Found
          </Typography>
        </Container>
        <AppFooter bgcolor={true} />
      </>
    );
  }

  return (
    <>
      <NavBar />
      <Container sx={{ mt: 16 }}>
        {/* <Box
          sx={{
            position: "sticky",
            top: { xs: "80px", sm: "80px" },
            zIndex: 999,
            backgroundColor: "background.default",
          }}
        >
          {ALL_CATEGORY.map((category) => (
            <Chip
              label={category[`title_${currentLanguage}`]}
              key={category.type}
              sx={{
                backgroundColor: "primary.main",
                color: "common.white",
                marginRight: 1,
                marginBottom: 1,
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "common.white",
                },
              }}
            />
          ))}
        </Box> */}
        <Grid container spacing={2}>
          {isLoading
            ? Array.from({ length: 3 }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <BlogsCardSkeleton />
                </Grid>
              ))
            : blogs.map((blog) => (
                <Grid item xs={12} sm={6} md={4} key={blog._id || blog.id}>
                  <BlogsCard blogData={blog} />
                </Grid>
              ))}
        </Grid>
      </Container>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default AllBlogs;
